"use client";

import { Core } from "@faire/slate/foundation/color";
import { iconCls } from "@faire/slate/lib/tracking";
import { createSVGIconV2 } from "@faire/web/slate/icons/lib/createSVGIconV2";
import React from "react";

// Implemented using the icons from here: https://faire-wholesale.slack.com/archives/C08PZGMUC3Z/p1756238353493689?thread_ts=1756237700.863289&cid=C08PZGMUC3Z
export const Shipping = createSVGIconV2(
  <path
    d="M2 7V16.4087C2 16.7734 2.19853 17.1092 2.51808 17.2849L12 22.5M2 7L12 12.5M2 7L6.75 4.25M22 6.86603L12.4672 1.75069C12.175 1.5939 11.8241 1.59215 11.5303 1.74601L6.75 4.25M22 6.86603V16.2816C22 16.6427 21.8054 16.9757 21.4909 17.1529L12 22.5M22 6.86603L17.25 9.75M12 22.5V12.5M12 12.5L17.25 9.75M17.25 9.75L6.75 4.25"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "Shipping",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    color: Core.icon.primary,
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
